import { css } from "@emotion/css"

type Props = {
  children: React.ReactNode
}

const MyPageDefinitionList = ({ children }: Props) => {
  return <dl className={styles.list}>{children}</dl>
}

export default MyPageDefinitionList

const styles = {
  list: css`
    display: flex;
    flex-direction: column;
    row-gap: 2px;
  `,
}
